import { filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'ngx-composicion-producto',
  templateUrl: './composicion-producto.component.html',
  styleUrls: ['./composicion-producto.component.scss']
})
export class ComposicionProductoComponent {

    @Input('composicion')
    composicion: any;

    fuentesComposicion = {
      micronutrientes:{
        label:'Micronutrientes',
        source:'../assets/jsondata/micronutrientes.json',
      },
      metalespesados:{
        label:'Metales pesados',
        source:'../assets/jsondata/metalesPesados.json',
      },
      macronutrientes:{
        label:'Macronutrientes',
        source:'../assets/jsondata/macronutrientes.json',
      }
    }

    @Output('composicion') valueChange = new EventEmitter<any[]>();

      @ViewChild('editarcomposicion')
      private editarDialog: TemplateRef<any>;

    constructor(private dialogService: NbDialogService,private httpClient:HttpClient){

    }

    async editarComposicion(tipo: string){
      let composicionData = {
        tipo: tipo,
        title: this.fuentesComposicion[tipo].label,
        composicion: await this.obtenerFuenteComposicion(this.fuentesComposicion[tipo].source),
      };

      composicionData.composicion.forEach(element => {

        let elemento = this.composicion[tipo].find( i => i.identifier == element.identifier);
        if(elemento && elemento.value && Number(elemento.value) > 0.0){
          element.value = elemento.value;
        }



      });

      this.dialogService.open(this.editarDialog,{context:{composicionData}});

    }


    obtenerFuenteComposicion(fuente: string): Promise<any>{
      return new Promise( (resolve,reject) => {
          this.httpClient.get(fuente).subscribe(valor => {
            resolve(valor);
          },error => {
            reject(error);
          });
      });
    }

    actualizarComposicion(tipo: string, composicion: any[]){
        this.composicion[tipo] = composicion.filter( i => i.value && Number(i.value) > 0.0);
        this.valueChange.emit(this.composicion);
    }
}
